// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * 全局参数 DTO类
 * 全局参数
 */
export class GlobalParamDTO {
  /** 环境变量名称 : 环境变量名称 */
  private _key: string;

  /** 设置：环境变量名称 */
  public get key() {
    return this._key;
  }

  /** 获取：环境变量名称 */
  public set key(value: string) {
    this._key = value;
  }

  /** 环境变量值 : 环境变量值 */
  private _value: string;

  /** 设置：环境变量值 */
  public get value() {
    return this._value;
  }

  /** 获取：环境变量值 */
  public set value(value: string) {
    this._value = value;
  }

  constructor() {
    this._key = '';
    this._value = '';
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.key = json.Key;
    this.value = json.Value;
  }

  protected Serialize(json: any): void {
    json.Key = this.key;
    json.Value = this.value;
  }

  static Create(json: any): GlobalParamDTO {
    const globalParamDTO = new GlobalParamDTO();
    globalParamDTO.Deserialize(json);
    return globalParamDTO;
  }
}
